import React from 'react';
import { Box, Divider, Stack } from '@mui/material';
import { Outlet, useParams } from 'react-router';
import { ROUTE_PARAMS } from '../../../utilities/navigation';
import { ChatInboxPage } from '../../chat/ChatInboxPage';

export const UserInboxPage = () => {
    const { [ROUTE_PARAMS.threadID]: threadID } = useParams();

    return (
        <Stack direction={'row'}>
            {/* Don't show side channels list for small screen */}
            <Box flex={2} display={{ xs: !threadID ? 'block' : 'none', md: 'block' }}
                minWidth={0} overflow={'hidden'}>
                <ChatInboxPage />
            </Box>
            <Divider flexItem orientation='vertical' />
            <Box flex={5} display={!threadID ? 'none' : 'block'}>
                <Outlet />
            </Box>
        </Stack>
    )
}